import React, { useEffect, useState } from 'react';
import { Menu, X, BookOpen } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const chapters = [{
  id: 'aviso',
  title: 'Aviso Importante'
}, {
  id: 'intro',
  title: 'Introducción'
}, {
  id: 'cap1',
  title: '1. Por qué la noche pega'
}, {
  id: 'cap2',
  title: '2. El error común'
}, {
  id: 'cap3',
  title: '3. El Protocolo 3R'
}, {
  id: 'cap4',
  title: '4. R1 — Re-encender'
}, {
  id: 'cap5',
  title: '5. R2 — Re-ocupar'
}, {
  id: 'cap6',
  title: '6. R3 — Re-conectar'
}, {
  id: 'cap7',
  title: '7. Las 10 noches'
}, {
  id: 'cap8',
  title: '8. Reiniciar sin culpa'
}, {
  id: 'cap9',
  title: '9. Cuatro perfiles'
}, {
  id: 'cap10',
  title: '10. Versión permanente'
}, {
  id: 'anexos',
  title: 'Anexos'
}];
export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeId, setActiveId] = useState('');
  // Handle scroll spy
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveId(entry.target.id);
        }
      });
    }, {
      rootMargin: '-20% 0px -35% 0px'
    });
    chapters.forEach(({
      id
    }) => {
      const element = document.getElementById(id);
      if (element) observer.observe(element);
    });
    return () => observer.disconnect();
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsOpen(false);
    }
  };
  return <>
      {/* Mobile Toggle */}
      <button onClick={() => setIsOpen(true)} className="fixed top-4 right-4 z-50 p-3 bg-navy-900/90 backdrop-blur-md border border-amber-500/30 rounded-full text-cream-100 shadow-lg lg:hidden" aria-label="Abrir menú" data-id="element-288">
        <Menu className="w-6 h-6" data-id="element-289" />
      </button>

      {/* Desktop Sidebar */}
      <nav className="hidden lg:block fixed top-0 left-0 h-screen w-72 bg-navy-950 border-r border-navy-800 p-8 overflow-y-auto z-40" data-id="element-290">
        <div className="mb-10 flex items-center gap-3 text-amber-500" data-id="element-291">
          <BookOpen className="w-6 h-6" data-id="element-292" />
          <span className="font-serif font-bold text-lg" data-id="element-293">10 Noches</span>
        </div>
        <ul className="space-y-4" data-id="element-294">
          {chapters.map(chapter => <li key={chapter.id} data-id="element-295">
              <button onClick={() => scrollToSection(chapter.id)} className={`text-left text-sm transition-colors duration-200 hover:text-amber-400 ${activeId === chapter.id ? 'text-amber-500 font-medium translate-x-1' : 'text-cream-300'}`} data-id="element-296">
                {chapter.title}
              </button>
            </li>)}
        </ul>
      </nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-297">
        {isOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 bg-navy-950/95 backdrop-blur-sm lg:hidden" data-id="element-298">
            <div className="flex flex-col h-full p-6" data-id="element-299">
              <div className="flex justify-between items-center mb-8" data-id="element-300">
                <div className="flex items-center gap-3 text-amber-500" data-id="element-301">
                  <BookOpen className="w-6 h-6" data-id="element-302" />
                  <span className="font-serif font-bold text-lg" data-id="element-303">Índice</span>
                </div>
                <button onClick={() => setIsOpen(false)} className="p-2 text-cream-100 hover:text-amber-500" data-id="element-304">
                  <X className="w-8 h-8" data-id="element-305" />
                </button>
              </div>

              <ul className="space-y-4 overflow-y-auto pb-8" data-id="element-306">
                {chapters.map(chapter => <li key={chapter.id} data-id="element-307">
                    <button onClick={() => scrollToSection(chapter.id)} className={`block w-full text-left py-2 text-lg border-b border-navy-800 ${activeId === chapter.id ? 'text-amber-500 font-medium' : 'text-cream-200'}`} data-id="element-308">
                      {chapter.title}
                    </button>
                  </li>)}
              </ul>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
};